// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"0f810cd7d52a3ef5","node_modules_canvg_lib_index_es_js":"33c41e462ab03eb5"}[chunkId] + ".js";
};